<h1 mat-dialog-title>Change Password</h1>
<div mat-dialog-content>
  <form [formGroup]="passwordForm">
    <mat-form-field appearance="fill" class="full-width">
      <mat-label>New Password</mat-label>
      <input matInput formControlName="newPassword" type="password" />
      <mat-error *ngIf="passwordForm.get('newPassword')?.hasError('required')">
        Password is required
      </mat-error>
      <mat-error *ngIf="passwordForm.get('newPassword')?.hasError('minlength')">
        Password must be at least 6 characters
      </mat-error>
    </mat-form-field>
  </form>
</div>
<div mat-dialog-actions align="end">
  <button mat-button (click)="onNoClick()">Cancel</button>
  <button
    mat-raised-button
    color="primary"
    [disabled]="passwordForm.invalid"
    (click)="save()">
    Change Password
  </button>
</div>
